export const resources = {
  en: {
    translation: {},
  },
  zh: {
    translation: {
      'Loading...': '加载中...',
      'Rendering error': '渲染错误',
      'Language': '语言',
      'English': 'English',
      '中文': '中文',
      'Sign In': '登录',
      'Start Free': '免费开始',
      'My Projects': '我的项目',
      'Marketplace': '交易市场',
      'Market': '市场',
      'Approval Dashboard': '审批工作台',
      'User Admin': '用户管理',
      'Billing & Plan': '套餐与额度',
      'Logout': '退出登录',
      'credits': 'credits',
      'Personal': '个人',
      'Enterprise': '企业',
      'Investor': '投资方',
      'Admin': '管理员',
      'Operator': '运营方',
      'Developer': '开发者',
      'Turn Renewable Energy Plants into Rated, Verified, Investable and Insurable Assets': '让新能源电站成为可评级、可验证、可投资、可保险的资产',
      'Built on AI agents, physics-based models, and verification workflows designed for real-world asset diligence.': '基于 AI 智能体、物理模型和验证工作流构建，面向真实世界的资产尽调场景。',
      'Jointly launched by': '联合发起方',
      'Why Trust Rater': '为什么相信 Rater',
      'Rater is designed for credible renewable energy asset evaluation, not just generic AI summarization.': 'Rater 面向可信的新能源资产评估，不只是通用的 AI 文本总结。',
      'Physics-grounded': '物理模型支撑',
      'Ratings are not generated from text alone. Rater combines AI agents with physics-based models to assess plant performance and loss drivers.': '评级并非仅由文本生成。Rater 将 AI 智能体与物理模型结合，用于评估电站表现与损失来源。',
      'Verification-ready': '验证链路完备',
      'Documents, satellite review, and process evidence are retained so operators and investors can see how a conclusion was reached.': '文档、卫星核验和流程证据会被完整保留，方便运营方和投资方追溯结论形成过程。',
      'Investment-oriented': '面向投资决策',
      'Outputs are structured for diligence, underwriting, and marketplace review, not just technical diagnostics.': '输出结果面向尽调、承保和市场审查，不只是技术诊断。',
      'How a Plant Becomes Rating-Ready': '电站如何成为可评级资产',
      'Upload': '上传',
      'Agent processing': '智能体处理中',
      'completed automatic basic rating': '已完成自动初级评级',
      '{{name}} uploaded and rating started': '{{name}} 已上传，评级已自动开始',
      'Plant specs & bills': '电站资料与账单',
      'Parse': '解析',
      'AI document extraction': 'AI 文档抽取',
      'Simulate': '仿真',
      'Irradiance & yield': '辐照与发电量',
      'Benchmark': '对标',
      'Industry comparison': '行业对比',
      'Diagnose': '诊断',
      'Fault detection': '故障识别',
      'Value': '估值',
      'Financial analysis': '财务分析',
      'Report': '报告',
      'Deep Diagnosis': '深度诊断',
      'Pool': '候选池',
      'Sale': '出售',
      'Apply to Pool': '申请入池',
      'Start sale review': '发起出售评估',
      'Authorize Visibility': '授权第三方可见',
      'Market Authorization': '市场授权',
      'Withdraw': '撤回',
      'Pause': '暂停',
      'Resubmit': '重新提交',
      'Mark Sold': '标记售出',
      'Request': '申请',
      'Annual revenue': '年收入',
      'Revenue Loss': '收入损失',
      'Remaining NPV': '剩余 NPV',
      'Value basis': '估值依据',
      'Current analysis layer': '当前评价层级',
      'Based on the data currently provided by the owner': '基于业主当前提供的数据',
      'Data completeness': '数据完整度',
      'High': '高',
      'Medium': '中',
      'Low': '低',
      'Technical grade': '技术评级',
      'Financial grade': '财务评级',
      'Risk grade': '风险评级',
      'Value reference': '价值参考',
      'Diagnostic TAR': '深度 TAR',
      'Basic TAR': '基础 TAR',
      'Preliminary TAR': '初步 TAR',
      'Needs generation data': '需要发电量数据',
      'Needs revenue data': '需要电费收入数据',
      'Satellite verified': '卫星已核验',
      'Satellite verification failed': '卫星核验失败',
      'Risk survey pending': '风险调查待完成',
      'Deep assessment requested': '已提交深度评价请求',
      'Failed to request deep assessment': '提交深度评价请求失败',
      'Deep assessment recommended': '建议进行深度评价',
      'The plant appears to underperform against comparable assets. Upload SCADA or inspection data for deeper diagnosis.': '该电站相对同类资产表现偏弱。请上传 SCADA 或检测数据，以便进行深度诊断。',
      'The initial assessment found performance risk. Upload SCADA or inspection data for a deeper diagnosis.': '初步评价发现性能风险。请上传 SCADA 或检测数据，以便进行深度诊断。',
      'This TAR is still based on partial data': '当前 TAR 仍基于部分数据',
      'To improve confidence, add': '如需提升可信度，请补充',
      'Listed on Market': '已上架市场',
      'QE visibility review pending': 'QE 可见性审核中',
      'Authorized for invited funds': '已授权受邀 fund 可见',
      'Owner Follow-up Actions': '业主后续动作',
      'Choose inspection, improvement, insurance, refinancing, or authorization actions based on this rating.': '基于本次评级选择检测、技改提升、保险、再融资或授权动作。',
      'Request QE Site Inspection': '申请 QE 现场检测',
      'Ask QE to coordinate an on-site inspection and verification scope.': '请 QE 协调现场检测和核验范围。',
      'Request QE Site Inspection?': '申请 QE 现场检测？',
      'QE will review this rating and coordinate the inspection scope with you.': 'QE 将查看本次评级，并与你协调检测范围。',
      'Owner requested QE site inspection from the rating page.': '业主在评级页申请 QE 现场检测。',
      'QE site inspection request submitted': '已提交 QE 现场检测申请',
      'Request Retrofit / Performance Improvement': '申请技改 / 性能提升',
      'Ask QE to review retrofit, rectification, or performance improvement options.': '请 QE 评估技改、整改或性能提升方案。',
      'Request retrofit / performance improvement?': '申请技改 / 性能提升？',
      'QE will review the current TAR result and follow up with improvement options.': 'QE 将基于当前 TAR 结果跟进提升方案。',
      'Owner requested retrofit or performance improvement support from the rating page.': '业主在评级页申请技改或性能提升支持。',
      'Retrofit request submitted': '已提交技改申请',
      'Request Insurance Quote': '索要保险报价',
      'Ask QE to prepare an insurance or renewal quote based on this rating.': '请 QE 基于本次评级准备保险或续保报价。',
      'Request insurance quote?': '索要保险报价？',
      'QE will use the rating result to coordinate an insurance or renewal quote.': 'QE 将基于评级结果协调保险或续保报价。',
      'Owner requested an insurance quote from the rating page.': '业主在评级页索要保险报价。',
      'Insurance quote request submitted': '已提交保险报价申请',
      'Request Refinancing Quote': '索要再融资报价',
      'Ask QE to coordinate refinancing or bank credit quote preparation.': '请 QE 协调再融资或银行授信报价准备。',
      'Request refinancing quote?': '索要再融资报价？',
      'QE will use the rating result to coordinate refinancing or bank credit quote preparation.': 'QE 将基于评级结果协调再融资或银行授信报价。',
      'Owner requested a refinancing quote from the rating page.': '业主在评级页索要再融资报价。',
      'Refinancing quote request submitted': '已提交再融资报价申请',
      'Authorize Third-party Visibility': '授权评级结果第三方可见',
      'Submit this asset to QE review before invited funds can see it in Market.': '提交 QE 审核，通过后受邀 fund 才能在 Market 看到该资产。',
      'Authorize third-party visibility?': '授权第三方可见？',
      'This sends the rating summary to QE review. Invited funds can see it only after QE approval.': '这会把评级摘要提交 QE 审核。只有 QE 通过后，受邀 fund 才能看到。',
      'Authorize and Submit': '授权并提交',
      'Authorize Downstream Financial Operations': '授权后续金融操作',
      'Authorize QE to use the rating result for follow-up financing, fund, or transaction workflows.': '授权 QE 将评级结果用于后续融资、基金或交易工作流。',
      'Authorize downstream financial operations?': '授权后续金融操作？',
      'This records owner authorization for QE to use this rating in controlled downstream financial workflows.': '这会记录业主授权，允许 QE 在受控后续金融工作流中使用本评级。',
      'Owner authorized downstream financial operations based on the rating result.': '业主基于评级结果授权后续金融操作。',
      'Downstream financial authorization recorded': '已记录后续金融操作授权',
      'Failed to create support request': '创建支持申请失败',
      'Start': '开始',
      'view': '次浏览',
      'views': '次浏览',
      'Rating certificate': '评级证书',
      'Backed by industry and research partners': '由产业与研究伙伴共同支持',
      'Pay-as-you-go · No subscriptions': '按用量付费 · 无需订阅',
      'Simple Credit Pricing': '简单透明的 Credit 定价',
      'Start free. Pay only for what you use. Every role gets a generous credit allowance — top up anytime at <1>USD 1 per credit</1>.': '免费开始，只为实际使用付费。每种角色都附带充足的 credit 配额，随时可按 <1>每个 credit 1 美元</1> 充值。',
      'Credit Usage by Action': '按动作计费',
      'Credits are charged per action, not per month. De-duped per plant — paying once gives permanent access.': 'Credit 按动作计费，而不是按月收费。同一电站去重收费，支付一次即可永久访问。',
      'All plans include SSL encryption and data privacy protection. Credits never expire. Top up anytime.': '所有套餐均包含 SSL 加密和数据隐私保护。Credit 永不过期，可随时充值。',
      'Action': '动作',
      'Who Pays': '付费方',
      'Cost': '费用',
      'Get Started': '开始使用',
      'Most Popular': '最受欢迎',
      // ── LandingPage ───────────────────────────────────────────────────────
      'Choose Your Plan': '选择套餐',
      'View full pricing details': '查看完整定价详情',
      'Contact Sales': '联系销售',
      'Free': '免费',
      'Rater — Powering transparent renewable asset transactions': 'Rater — 驱动透明的新能源资产交易',
      'No subscription — pay per credit': '无需订阅，按 credit 付费',
      '1 auto AI rating + 1 human approval': '1 次自动 AI 评级 + 1 次人工审批',
      'Human approval: purchase credits separately': '人工审批：单独购买 credits',
      'Portfolio management & batch listing': '资产组合管理与批量上架',
      'Contact info / full report: 1 credit/plant': '联系方式 / 完整报告：每个电站 1 credit',
      'Welcome back!': '欢迎回来！',
      'Login failed': '登录失败',
      'Please enter your email': '请输入邮箱',
      'Invalid email format': '邮箱格式无效',
      'Email address': '邮箱地址',
      'Please enter your password': '请输入密码',
      'Password': '密码',
      'Account created!': '账号已创建！',
      'Registration failed': '注册失败',
      'Please create a password': '请创建密码',
      'Minimum 8 characters': '至少 8 个字符',
      'Please confirm your password': '请确认密码',
      'Passwords do not match': '两次输入的密码不一致',
      'Confirm password': '确认密码',
      'I am a': '我的身份是',
      'Select your role (optional)': '选择角色（可选）',
      'Personal (Plant Owner)': '个人（电站业主）',
      'Enterprise (Corporate Owner)': '企业（公司业主）',
      'Investor (Asset Management)': '投资方（资产管理）',
      'Create Account': '创建账户',
      'Please enter a phone number': '请输入手机号',
      'OTP sent!': '验证码已发送！',
      'Failed to send OTP': '发送验证码失败',
      'Please enter the verification code': '请输入验证码',
      'Verified!': '验证成功！',
      'Verification failed': '验证失败',
      'Phone number': '手机号',
      'Send Code': '发送验证码',
      'Code sent to {{phone}}': '验证码已发送至 {{phone}}',
      'Enter 6-digit code': '输入 6 位验证码',
      'Verify': '验证',
      'Use a different number': '使用其他号码',
      'No version history yet': '暂无版本历史',
      'No replay deltas recorded': '暂无 replay 差异记录',
      'Version': '版本',
      'Status': '状态',
      'Rating': '评级',
      'Replay': '回放',
      'Drift Summary': '漂移摘要',
      'Metric': '指标',
      'Before': '前值',
      'After': '后值',
      'Delta': '差值',
      'Changed': '是否变化',
      'Replay completed: {{status}}': '回放完成：{{status}}',
      'Failed to replay version': '回放版本失败',
      'Created candidate version v{{version}} pending approval': '已创建待审批候选版本 v{{version}}',
      'Failed to rerun version': '重新运行版本失败',
      'Process Details': '过程详情',
      'Parameters saved. Rating is now pending approval.': '参数已保存，评级已进入待审批状态。',
      'Failed to load process details': '加载过程详情失败',
      'Failed to start a new chat': '创建新对话失败',
      'Failed to switch chat thread': '切换对话线程失败',
      'Model': '模型',
      'Type a message...': '输入消息...',
      'Name': '名称',
      'Owner': '业主',
      'Created By': '创建人',
      'Capacity': '容量',
      'Created': '创建时间',
      'Draft': '草稿',
      'Analyzing': '分析中',
      'Rated': '已评级',
      'Listed': '已上架',
      'Unrated': '未评级',
      'Unnamed': '未命名',
      'Dashboard': '概览',
      'List': '列表',
      'Map': '地图',
      'Loading admin dashboard...': '正在加载管理看板...',
      'Admin Dashboard': '管理看板',
      'Approval API Not Connected': '审批接口尚未接通',
      'Admin API Not Connected': '管理接口尚未接通',
      'Total Plants': '电站总数',
      'Avg CPN Score': '平均 TAR 分数',
      'Avg TAR Score': '平均 TAR 分数',
      'Pending EL': '待处理 EL',
      'At Risk': '风险项目',
      'All Plants': '全部电站',
      'No plants found.': '未找到电站。',
      '{{total}} plants': '{{total}} 个电站',
      'By Rating': '按评级查看',
      'No data for chart': '暂无图表数据',
      '{{count}} plants': '{{count}} 个电站',
      '+{{count}} more': '另有 {{count}} 个',
      'By Region': '按区域查看',
      'Region-based breakdown will be available when plant location data is populated.': '补齐电站位置信息后，将显示按区域拆分结果。',
      'REITs': 'REITs',
      'REIT Bundle Management': 'REIT 组合管理',
      'Bundle rated plants into investment vehicles. Coming soon.': '将已评级电站打包为投资载体。即将推出。',
      'Use the floating chat to query your data: "Show all C/D rated plants" or "Plants above 10 MW"': '使用右下角对话框查询数据，例如：“显示所有 C/D 评级电站”或“列出 10 MW 以上电站”。',
      'Failed to load admin data': '加载管理数据失败',
      'Admin API endpoints will be available after backend integration.': '后端集成完成后，管理接口将可用。',
      'Billing': '账单',
      'Plan': '套餐',
      'Current Plan': '当前套餐',
      'Credits Remaining': '剩余 Credits',
      'Token Usage': 'Token 使用量',
      'Usage Cap': '使用上限',
      'Unlimited': '无限制',
      'Usage': '使用情况',
      'Current consumption': '当前消耗',
      'Token usage progress': 'Token 使用进度',
      '{{count}} used': '已使用 {{count}}',
      'Plan Options': '套餐选项',
      'Current benefits': '当前权益',
      'Internal accounts can review usage and top up credits here.': '内部账号可在此查看使用情况并充值 credits。',
      'Switch guidance is handled through support at this stage.': '当前阶段的套餐变更由支持团队协助处理。',
      'Internal account': '内部账号',
      'Internal roles are not part of the public Personal / Enterprise / Investor catalog, but you can still review plan details below.': '内部角色不属于公开的个人 / 企业 / 投资方套餐目录，但仍可在下方查看套餐信息。',
      'Request Change': '申请变更',
      'Top Up': '充值',
      'Popular': '热门',
      'Purchase': '购买',
      'a Package': '套餐',
      'Usage History': '使用记录',
      'Refresh': '刷新',
      'Export CSV': '导出 CSV',
      'Filter by reason': '按原因筛选',
      '{{total}} records': '{{total}} 条记录',
      'Usage Breakdown': '使用拆分',
      'Usage Summary': '使用汇总',
      'Total Spent': '累计支出',
      'Total Topped Up': '累计充值',
      'Usage by Reason': '按原因统计',
      'No transactions yet.': '暂无交易记录。',
      '{{total}} credits ({{count}}x)': '{{total}} credits（{{count}} 次）',
      'Action Pricing Reference': '动作计费参考',
      'Payment Instructions': '支付说明',
      'Package': '套餐',
      'Price': '价格',
      'Amount': '金额',
      'Instructions': '说明',
      'Got it': '知道了',
      'Confirm Purchase': '确认购买',
      'Change to {{plan}}': '切换到 {{plan}}',
      'Plan changes are currently handled by the support team. Please email': '当前套餐变更由支持团队处理。请发送邮件至',
      'with your account email and the target plan, and the team will guide the change.': '，附上你的账号邮箱和目标套餐，团队会协助处理。',
      'Top Up Credits': '充值 Credits',
      'Change Plan': '更换套餐',
      '{{plan}} account overview': '{{plan}} 账户概览',
      'Review your current plan, usage, transaction history, top-up options, and plan change paths in one place.': '在一个页面中查看当前套餐、使用情况、交易记录、充值选项和套餐变更路径。',
      'Export failed': '导出失败',
      'Top-up failed': '充值失败',
      'Date': '日期',
      'Reason': '原因',
      'Plant': '电站',
      'Close': '关闭',
      'Select at least one live asset to favorite': '请至少选择一个真实资产进行收藏',
      'Added {{count}} asset(s) to favorites': '已收藏 {{count}} 个资产',
      'Failed to batch favorite assets': '批量收藏资产失败',
      'Favorites are available for live marketplace assets only.': '收藏功能仅适用于真实上架资产。',
      'Added to favorites': '已加入收藏',
      'Removed from favorites': '已取消收藏',
      'Failed to update favorites': '更新收藏失败',
      'Contact available when marketplace is live.': '市场正式上线后可联系业主。',
      'Failed to express intent': '表达意向失败',
      'Clear Selection': '清空选择',
      'Select Visible': '选择当前可见项',
      'Favorite Selected': '收藏所选',
      'Preview Mode': '预览模式',
      'Marketplace is being set up. Showing sample listings to preview the layout.': '交易市场仍在搭建中，当前展示示例列表用于预览布局。',
      'Live assets will appear once owners list renewable energy assets for refinance, reinsurance, or investment review.': '当业主将新能源资产上架用于再融资、再保险或投资审查后，真实资产将显示在这里。',
      'Region': '区域',
      'All Regions': '全部区域',
      'Southeast Asia': '东南亚',
      'Europe': '欧洲',
      'North America': '北美',
      'Japan': '日本',
      'Australia': '澳大利亚',
      'All Ratings': '全部评级',
      'A (Excellent)': 'A（优秀）',
      'B (Good)': 'B（良好）',
      'C (Fair)': 'C（一般）',
      'D (Poor)': 'D（较差）',
      'Any Capacity': '任意容量',
      '< 1 MW': '< 1 MW',
      '1 - 5 MW': '1 - 5 MW',
      '5 - 20 MW': '5 - 20 MW',
      '> 20 MW': '> 20 MW',
      'Newest First': '最新优先',
      'Highest Score': '最高分优先',
      'Largest Capacity': '容量最大优先',
      'Search by name or location...': '按名称或位置搜索...',
      'Total Capacity': '总容量',
      'Avg CPN': '平均 TAR',
      'Avg TAR': '平均 TAR',
      'REIT Bundles': 'REIT 组合',
      'Fix Opportunities': '修复机会',
      'Featured: {{title}}': '精选：{{title}}',
      'plants': '个电站',
      'Avg Score': '平均分',
      'View Dossier': '查看资料包',
      'Bundle dossier will be available when marketplace is live.': '市场正式上线后可查看组合资料包。',
      'Opening bundle dossier...': '正在打开组合资料包...',
      'Contact': '联系',
      'No assets match your filters': '没有资产符合当前筛选条件',
      'Contact Plant Owner': '联系电站业主',
      'Processing...': '处理中...',
      'Previously contacted — no additional charge.': '此前已联系过，不再重复扣费。',
      '1 credit charged.': '已扣除 1 credit。',
      'Email': '邮箱',
      'Phone': '电话',
      'Owner has not provided contact details yet. The owner has been notified of your interest.': '业主暂未提供联系方式，系统已通知对方你的兴趣意向。',
      'Loading marketplace...': '正在加载交易市场...',
      'Renewable Asset Marketplace': '新能源资产交易市场',
      'Clear': '清空',
      'This is a demo listing. Detailed rating will be available when marketplace is live.': '这是示例资产。市场正式上线后可查看详细评级。',
      'View Plant Rating Details': '查看电站评级详情',
      'Viewing the detailed rating report of this plant will cost 1 credit. Continue?': '查看该电站的详细评级报告将消耗 1 credit。是否继续？',
      'Confirm (1 Credit)': '确认（1 Credit）',
      'Cancel': '取消',
      'My Renewable Plants': '我的新能源电站',
      'Loading portfolio...': '正在加载项目列表...',
      'Create Plant': '创建电站',
      'Create': '创建',
      'Plant name': '电站名称',
      'Select owner (optional)': '选择业主（可选）',
      'Leaving owner empty keeps the project under your own account. Choosing an owner creates the project for that customer while keeping it in your portfolio until transfer.': '留空则项目保留在你自己的账户下。选择业主后，项目会为该客户创建，并在移交前继续保留在你的项目列表中。',
      'Plant created': '电站已创建',
      'Failed to create plant': '创建电站失败',
      'Failed to load owner options': '加载业主选项失败',
      'Pending analysis': '待分析',
      'Search plants...': '搜索电站...',
      'Clear All': '清空全部',
      'Select All': '全选',
      '{{count}} selected': '已选择 {{count}} 项',
      'Delete': '删除',
      'Export Reports': '导出报告',
      'Compare': '对比',
      'List on Marketplace': '上架市场',
      'No plants match your search.': '没有电站符合当前搜索条件。',
      'Loading map...': '正在加载地图...',
      'Delete {{count}} plant(s)? This cannot be undone.': '确认删除 {{count}} 个电站？此操作不可撤销。',
      '{{count}} plant(s) deleted': '已删除 {{count}} 个电站',
      'Downloading {{count}} report(s)...': '正在下载 {{count}} 份报告...',
      'Select at least 2 plants to compare': '请至少选择 2 个电站进行对比',
      '{{count}} plant(s) listed on marketplace.': '已有 {{count}} 个电站上架市场。',
      '{{count}} plant(s) could not be listed (not rated or access denied).': '{{count}} 个电站无法上架（未评级或无权限）。',
      'Failed to list plants': '上架电站失败',
      'Grid': '网格',
      'Unnamed Plant': '未命名电站',
      'Avg Rating': '平均评级',
      'Seller': '业主',
      'Internal Admin': '内部管理员',
      'Internal Operator': '内部运营',
      'Standard AI Tier': '标准 AI 档位',
      'Paid AI Tier': '付费 AI 档位',
      'AI Tokens (1M)': 'AI Tokens（1M）',
      'Top-up (Manual)': '手动充值',
      'Top-up (Stripe)': 'Stripe 充值',
      'Promo': '赠送',
      'Initial Grant': '初始发放',
      'View Details': '查看详情',
      'Download PDF': '下载 PDF',
      'Contact Owner': '联系业主',
      'AI Rating': 'AI 评级',
      'Human Approval': '人工审批',
      'Health Check Submit': '提交健康检查',
      'Individual plant owners': '个人电站业主',
      'Professional asset owners': '专业资产业主',
      'Asset managers & investors': '资产管理方与投资人',
      '10 free credits': '10 个免费 credits',
      '500 free credits': '500 个免费 credits',
      '1000 free credits': '1000 个免费 credits',
      'USD 1 / extra credit': '额外 credit 每个 1 美元',
      'Bulk discount available': '支持批量折扣',
      'USD 1 / action credit': '每次动作 1 美元',
      'Up to 1 plant': '最多 1 个电站',
      'Auto AI rating (1 credit/submission)': '自动 AI 评级（每次提交 1 credit）',
      '1 human approval included': '含 1 次人工审批',
      'Marketplace: browse list & TDD summary': '交易市场：浏览列表与 TDD 摘要',
      'Marketplace: full report / contact info': '交易市场：完整报告 / 联系方式',
      'Multiple plants': '多个电站',
      'Bulk credit discount': '批量 credit 折扣',
      'Up to 50 plants': '最多 50 个电站',
      'Unlimited auto AI ratings': '无限次自动 AI 评级',
      'Human approval (purchase credits)': '人工审批（购买 credits）',
      'Portfolio management dashboard': '资产组合管理看板',
      'Batch marketplace listing': '批量上架交易市场',
      'Priority analysis queue': '优先分析队列',
      'Browse marketplace list & TDD summary (free)': '浏览交易市场列表与 TDD 摘要（免费）',
      'Contact owner info (1 credit/plant)': '联系业主信息（每个电站 1 credit）',
      'Full report & deep details (1 credit/plant)': '完整报告与深度细节（每个电站 1 credit）',
      'Express investment intent (1 credit/plant)': '表达投资意向（每个电站 1 credit）',
      'LLM-powered deal analysis': 'LLM 驱动的交易分析',
      'Human due-diligence support (extra credits)': '人工尽调支持（额外 credits）',
      'Compare & portfolio tools': '对比与组合工具',
      'Auto AI Rating': '自动 AI 评级',
      'Owner (Personal / Enterprise)': '业主（个人 / 企业）',
      '1 credit / submission': '每次提交 1 credit',
      'Owner (Enterprise+)': '业主（企业及以上）',
      '1 credit / approval': '每次审批 1 credit',
      'View Full Report': '查看完整报告',
      '1 credit / plant (de-duped)': '每个电站 1 credit（去重）',
      'Contact Owner Info': '联系业主信息',
      'Express Intent': '表达意向',
      'AI Chat (LLM)': 'AI 对话（LLM）',
      'All roles': '全部角色',
      '1 credit / 1M tokens': '每 1M tokens 1 credit',
      'Human Due-Diligence': '人工尽调',
      'Custom (extra credits)': '自定义（额外 credits）',
      'OK': '确定',
      'Fix Opportunity': '修复机会',
      'Under Review': '审核中',
      'CPN Score': 'TAR 分数',
      'TAR Score': 'TAR 分数',
      'PR (corrected)': 'PR（校正后）',
      'Valuation': '估值',
      'Post-fix IRR': '修复后 IRR',
      'Fix Cost': '修复成本',
      'Annual Yield': '年发电量',
      'Revenue': '收益',
      'How can I help you today?': '今天我可以帮你做什么？',
      'Done': '已完成',
      'Thinking...': '思考中...',
      'Rater AI': 'Rater AI',
      'Threads': '对话线程',
      'New Chat': '新建对话',
      'No previous conversations yet': '还没有历史对话',
      'Untitled Chat': '未命名对话',
      'No summary yet': '暂无摘要',
      'Minimize': '最小化',
      'Expand': '展开',
      'Collapse': '收起',
      'Attach file': '添加文件',
      'Stop': '停止',
      'Send': '发送',
      'Failed to load rating': '加载评级失败',
      'Rating Not Computed': '尚未计算评级',
      'This plant has not been submitted for rating yet. Complete the required plant information and uploaded data, then submit it for rating.': '该电站尚未提交评级。请先补充必要的电站信息和上传数据，然后提交评级。',
      'Prepare Data': '准备数据',
      'You do not have access to this plant. Please sign in with the correct account.': '你无权访问该电站，请使用正确账号登录。',
      'Download failed': '下载失败',
      'Failed to download PDF': '下载 PDF 失败',
      'Insurance quote generated': '保险报价已生成',
      'Failed to get insurance quote': '获取保险报价失败',
      'Risk analysis failed': '风险分析失败',
      'unknown error': '未知错误',
      'Improve': '改进支持',
      'I need further inspection and optimization support for this plant. Please help me gather the requirement, summarize it, ask for my confirmation, and then create a support request.': '我需要这个电站的进一步检测和优化支持。请先帮我收集需求、整理摘要、让我确认，然后再创建支持请求。',
      'I am reviewing this pending rating. Please prepare an approval draft with action, rating, CPN score, and a concise comment. Let me edit any field, and only after my explicit confirmation should you submit the review.': '我正在审核这个待审批评级。请先生成一个审批草案，包含操作、评级、TAR 分数和简洁评论。让我可以修改任意字段，并且只有在我明确确认后才提交审批。',
      'I am reviewing this pending rating. Please prepare an approval draft with action, rating, TAR score, and a concise comment. Let me edit any field, and only after my explicit confirmation should you submit the review.': '我正在审核这个待审批评级。请先生成一个审批草案，包含操作、评级、TAR 分数和简洁评论。让我可以修改任意字段，并且只有在我明确确认后才提交审批。',
      'Failed to open approval chat': '打开审批对话失败',
      'Review in Chat': '在对话中审核',
      'Transfer this project to the owner and remove it from your My Projects list?': '将该项目移交给业主，并从你的“我的项目”列表中移除？',
      'Transfer to Owner': '移交给业主',
      'Project transferred to owner': '项目已移交给业主',
      'Failed to transfer project': '移交项目失败',
      'Owner updated and listing sent back to review': '业主已更新，挂牌已送回审核',
      'Project submitted for marketplace review': '项目已提交市场审核',
      'Marketplace application withdrawn': '市场申请已撤回',
      'Marketplace listing paused': '市场挂牌已暂停',
      'Project resubmitted for marketplace review': '项目已重新提交市场审核',
      'Sale confirmation submitted for operator review': '出售确认已提交运营方审核',
      'Confirm Marketplace Listing Price': '确认市场挂牌价格',
      'Confirm Price and Submit': '确认价格并提交',
      'System recommended price': '系统推荐价格',
      'This is the listing price shown on Marketplace after review. Please confirm it before submitting the project.': '这是审核通过后展示在市场中的挂牌价格，请在提交前确认。',
      'Confirmed listing price': '已确认挂牌价格',
      'Price unavailable': '价格不可用',
      'Capacity, rating or score data is incomplete. Complete the rating data before submitting this project to Marketplace.': '容量、评级或分数数据不完整。请先完善评级数据，再提交到市场。',
      'Submit Sale Confirmation': '提交出售确认',
      'Submit Sale Request': '提交出售申请',
      'Buyer Name': 'Fund 名称',
      'Buyer name is required': '请填写 fund 名称',
      'Buyer legal entity or individual': 'Fund 法人主体或机构',
      'Buyer Email': 'Fund 邮箱',
      'Buyer Phone': 'Fund 电话',
      'Fund Name': 'Fund 名称',
      'Fund name is required': '请填写 fund 名称',
      'Fund legal entity or institution': 'Fund 法人主体或机构',
      'Fund Email': 'Fund 邮箱',
      'Fund Phone': 'Fund 电话',
      'Fund email or phone is required': '请填写 fund 邮箱或电话',
      'Sold Date': '成交日期',
      'Sold date is required': '请填写成交日期',
      'Supporting evidence is required': '请填写支持证明',
      'Contract signed, email confirmation, settlement memo, or other supporting evidence.': '已签署合同、邮件确认、结算备忘录或其他支持证明。',
      'Change Project Owner': '变更项目业主',
      'Confirm Owner Change': '确认变更业主',
      'New Owner': '新业主',
      'Please select a new owner': '请选择新业主',
      'Select a new owner': '选择新业主',
      'Change Reason': '变更原因',
      'Please record why this owner change is needed': '请记录需要变更业主的原因',
      'Examples: sold offline, duplicate owner corrected, wrong assignee fixed': '例如：线下售出、重复业主修正、分配对象错误修复',
      'Please record the supporting evidence for this owner change': '请记录本次业主变更的支持证明',
      'Contract reference, confirmation email, settlement note, or other proof used for this manual owner change.': '合同编号、确认邮件、结算说明或其他用于手动变更业主的证明。',
      'Changing the owner removes the project from the live market and sends the listing back to operator review.': '变更业主会将项目从市场下架，并把挂牌送回运营方审核。',
      'Loading rating data...': '正在加载评级数据...',
      'Go Back': '返回',
      'No rating data available. Submit your plant for analysis first.': '暂无评级数据，请先提交电站进行分析。',
      'Saved': '已收藏',
      'Save': '收藏',
      'Favorited': '已收藏',
      'Favorite': '收藏',
      'Refinance': '再融资',
      'Insurance': '保险',
      'Services': '服务',
      'Contact QE Support': '联系 QE 支持',
      'Insurance Quote': '保险报价',
      'Availability': '可用率',
      'Basic Info': '基础信息',
      'Technical (TDD)': '技术尽调（TDD）',
      'Loss Waterfall': '损失瀑布图',
      'CPN Radar': 'TAR 雷达图',
      'TAR Radar': 'TAR 雷达图',
      'Financial (FDD)': '财务尽调（FDD）',
      'Current Approval Status': '当前审批状态',
      'By': '审批人',
      'When': '时间',
      'Comments': '评论',
      'Approve': '批准',
      'Approval actions are available only to operator, admin, and dev roles.': '只有 operator、admin 和 dev 角色可以执行审批操作。',
      'Approval Comment': '审批评论',
      'Leave a required review note before approving or rejecting this rating.': '在批准或拒绝前，请填写必要的审批说明。',
      'Explain why this rating should be approved or rejected...': '说明为什么这个评级应该被批准或拒绝...',
      'Reject': '拒绝',
      'Review notes and approval decisions are tracked below. You do not have permission to submit a new review.': '审批说明和审批决定会记录在下方。你无权提交新的审批。',
      'Approval History': '审批历史',
      'Failed to load approval history': '加载审批历史失败',
      'Comment is required': '必须填写评论',
      'Approved successfully': '批准成功',
      'Rejected successfully': '拒绝成功',
      'Review failed': '审批失败',
      'Commercial Status': '商业状态',
      'unknown': '未知',
      'approval n/a': '审批状态不可用',
      'Commissioned': '并网年份',
      'Submitted': '提交时间',
      'Not provided': '未提供',
      'Owner profile incomplete': '业主资料不完整',
      'Hidden until due diligence unlock': '尽调解锁前隐藏',
      'Rating Snapshot': '评级快照',
      'Basic plant information': '电站基础信息',
      'Generation performance data': '发电表现数据',
      'Revenue or electricity bill data': '收入或电费账单数据',
      'Satellite verification': '卫星核验',
      'Detailed inspection data': '详细检测数据',
      'Pending revenue data': '收入数据待补充',
      'TAR Analysis': 'TAR 分析',
      'Detailed TDD charts are temporarily unavailable for this asset. Core technical indicators are still shown below.': '该资产的详细技术尽调图表暂不可用。下方仍会展示核心技术指标。',
      'Technical Radar': '技术雷达图',
      'Technical Score': '技术分',
      'Financial performance': '财务表现',
      'Post-fix ROI': '修复后 ROI',
      'Remaining Life NPV': '剩余寿命 NPV',
      'Risk and confidence': '风险与可信度',
      'QE Pending': 'QE 待核验',
      'Satellite Confirmed': '卫星已确认',
      'Satellite Pending': '卫星待确认',
      'Risk survey has not been generated yet. The current TAR uses available asset and verification signals.': '尚未生成风险调查。当前 TAR 使用已有资产信息和核验信号。',
      'Data used for this TAR': '本次 TAR 使用的数据',
      'Supplement data': '补充数据',
      'Risk Survey': '风险调查',
      'PV Evidence': '光伏证据',
      'Inspection Details': '检测详情',
      'No detailed inspection has been completed for this plant yet.': '该电站尚未完成详细检测。',
      'The current page shows a basic TAR based on the owner-provided plant, generation, and revenue data. Upload inverter/string/O&M evidence or request deep diagnosis to unlock inspection findings.': '当前页面展示的是基于业主提供的电站、发电量和收入数据生成的基础 TAR。上传逆变器、组串、运维等证据，或申请深度诊断后，可查看检测结论。',
      'Files & Evidence': '文件与证据',
      'ESG': 'ESG',
      'Carbon': '碳资产',
      'No approval history yet': '暂无审批历史',
      'Approved': '已批准',
      'Rejected': '已拒绝',
      'system': '系统',
      'Note': '备注',
      'Measured': '实测',
      'Owner-declared': '业主申报',
      'Modelled': '模型估算',
      'Source': '来源',
      'Step': '步骤',
      'No parameter changes to save': '没有可保存的参数变更',
      'Failed to adjust parameters': '调整参数失败',
      'Adjust Rating Parameters': '调整评级参数',
      'Save & Trigger Re-rating': '保存并触发重新评级',
      'Changing these parameters creates a new rating version (pending approval).': '修改这些参数会创建一个新的评级版本（待审批）。',
      'The old version is preserved for audit. All changes are logged with the reason you provide.': '旧版本会被保留用于审计，所有改动都会连同你填写的原因一并记录。',
      'Tilt angle': '倾角',
      'Azimuth': '方位角',
      'Albedo': '反照率',
      'Timezone offset': '时区偏移',
      'Tariff': '电价',
      'Discount rate': '折现率',
      'Project life': '项目寿命',
      'PLR (annual)': '年衰减率（PLR）',
      'Reason for change': '变更原因',
      'Please provide a reason': '请填写变更原因',
      'e.g. Owner provided updated tilt from 15° to 22°, verified with design documents.': '例如：业主提供了更新后的倾角，从 15° 调整为 22°，并已通过设计文件核验。',
      'Agent': '代理',
      'Tokens': 'Tokens',
      'Input': '输入',
      'Output': '输出',
      'Error': '错误',
      'No version selected': '尚未选择版本',
      'No replay validation has been run for this version yet': '该版本尚未执行 replay 校验',
      'Legacy snapshot': '历史快照',
      'This version was backfilled from historical plant data. Replay is unavailable because no full health input/output snapshot was stored.': '该版本由历史电站数据回填而来。由于未保存完整的 health 输入/输出快照，因此无法执行 replay。',
      'Replay validation failed': '回放校验失败',
      'Replay Status': '回放状态',
      'Checked': '检查时间',
      'Matched': '一致',
      'Legacy backfill snapshot — replay unavailable': '历史回填快照，无法 replay',
      'No replay recorded': '暂无 replay 记录',
      'No drift detected': '未发现漂移',
      '{{count}} deltas detected': '检测到 {{count}} 处差异',
      'parent linked': '关联父版本',
      'Selected': '已选中',
      'Inspect': '查看',
      'No simulation parameters recorded for this version': '该版本未记录仿真参数',
      'Set Parameters': '设置参数',
      'Adjust Parameters': '调整参数',
      'Simulation Parameters': '仿真参数',
      'Financial Parameters': '财务参数',
      'No parameter changes yet': '暂无参数变更记录',
      'Field': '字段',
      'Old → New': '旧值 → 新值',
      'As an investor, viewing process details consumes 1 credit per plant version (already charged). Switching versions will charge again.': '作为投资方，查看过程详情会按每个电站版本消耗 1 credit（若已扣费则不会重复计入本次）。切换版本会再次扣费。',
      'Running Replay...': '正在回放...',
      'Creating Candidate...': '正在创建候选版本...',
      'Replay Validation': '回放校验',
      'Replay & Drift History': '回放与漂移历史',
      'Key Metrics': '关键指标',
      'Analysis Pipeline': '分析流程',
      'Parameter Change History': '参数变更历史',
      'Failed to load ESG assessment': '加载 ESG 评估失败',
      'ESG assessment saved (pending approval)': 'ESG 评估已保存（待审批）',
      'ESG certificate issued': 'ESG 证书已签发',
      'No ESG assessment yet': '暂无 ESG 评估',
      'Create Assessment': '创建评估',
      'Certified': '已认证',
      'Expires': '到期',
      'Edit': '编辑',
      'Issue Certificate': '签发证书',
      'Overall ESG Grade': 'ESG 总评级',
      '🌱 Environmental (40%)': '🌱 环境（40%）',
      'CO₂ avoided': '减少 CO₂ 排放',
      'tonnes/yr': '吨/年',
      'Water saved': '节水量',
      'm³/yr': '立方米/年',
      'Land use': '占地面积',
      'hectares': '公顷',
      '👥 Social (30%)': '👥 社会（30%）',
      'Jobs created': '创造就业',
      'Benefit': '收益',
      'Transparency': '透明度',
      'Compliance': '合规性',
      'ESG Framework': 'ESG 框架',
      'Scores align with GRI / SASB / TCFD standards. Certification is issued by Rater after admin review and valid for 12 months.': '评分对齐 GRI / SASB / TCFD 标准。证书由 Rater 在管理员审核后签发，有效期 12 个月。',
      'ESG Assessment': 'ESG 评估',
      '🌱 Environmental': '🌱 环境',
      'Score (0-100)': '分数（0-100）',
      'CO₂ avoided (t/yr)': '减少 CO₂ 排放（吨/年）',
      'Water saved (m³/yr)': '节水量（立方米/年）',
      'Land use (hectares)': '占地面积（公顷）',
      '👥 Social': '👥 社会',
      'Community benefit description': '社区收益说明',
      '⚖️ Governance': '⚖️ 治理',
      'Failed to load carbon credits': '加载碳信用失败',
      'Calculated': '已计算',
      'Verify carbon credit': '核验碳信用',
      'Mark this credit as verified. Registry and serial number can be set separately.': '将这笔碳信用标记为已核验。登记机构和序列号可后续单独设置。',
      'Verified': '已核验',
      'Credit retired': '碳信用已注销',
      'Vintage': '年份批次',
      'Tonnes CO₂e': '吨 CO₂e',
      'Methodology': '方法学',
      'Registry': '登记机构',
      'Serial': '序列号',
      'Actions': '操作',
      'Retire': '注销',
      'Total Calculated': '累计计算',
      'Retired (offset used)': '已注销（已抵消使用）',
      'Calculate New Vintage': '计算新批次',
      'No carbon credits calculated yet': '暂无已计算的碳信用',
      'Carbon Offset Methodology': '碳抵消方法学',
      'Formula': '公式',
      'Default regional factors per IEA/IPCC AR6. For registry-grade credits, use CDM AMS-I.D, VCS VM0007, or Gold Standard methodologies and submit for third-party verification.': '默认区域因子参考 IEA/IPCC AR6。若要达到注册级碳信用，请使用 CDM AMS-I.D、VCS VM0007 或 Gold Standard 方法学，并提交第三方核验。',
      'Calculate Carbon Offset': '计算碳抵消量',
      'Annual generation (MWh)': '年发电量（MWh）',
      'Grid region': '电网区域',
      'Vintage year': '年份批次',
      'Override grid EF (tCO₂/MWh, optional)': '覆盖电网排放因子（tCO₂/MWh，可选）',
      'leave empty for regional default': '留空则使用区域默认值',
      'Methodology (optional)': '方法学（可选）',
      'e.g. CDM AMS-I.D, VCS VM0007, Gold Standard': '例如：CDM AMS-I.D、VCS VM0007、Gold Standard',
      'Retire Carbon Credit': '注销碳信用',
      'Retiring permanently removes the credit from active use — it cannot be undone.': '注销会永久将该碳信用从可用状态中移除，且无法撤销。',
      'Retirement beneficiary': '注销受益方',
      'Please specify a beneficiary': '请填写受益方',
      'e.g. Acme Corp Scope-2 offset for 2026': '例如：Acme Corp 2026 年 Scope-2 抵消',
      'Failed to load plant data': '加载电站数据失败',
      'My RE Plants': '我的新能源电站',
      '{{count}} plant(s) in your portfolio': '你的资产组合中共有 {{count}} 个电站',
      'No plants yet — create your first plant to get started': '还没有电站，先创建你的第一个项目吧',
      'Welcome to Rater — your RE asset rating platform': '欢迎使用 Rater，你的新能源资产评级平台',
      'Upload your plant documents and chat with our AI assistant to evaluate performance, identify risks, and get a CPN rating.': '上传电站资料，并与 AI 助手对话，以评估表现、识别风险并获取 TAR 评级。',
      'Create Your First Plant': '创建你的第一个电站',
      'Failed to delete plant': '删除电站失败',
      'Analysis Progress': '分析进度',
      '{{done}}/{{total}} done': '已完成 {{done}} / {{total}}',
      'View Rating Report': '查看评级报告',
      'Download PDF Report': '下载 PDF 报告',
      'Rating: {{rating}} (CPN {{score}}) — navigating...': '评级：{{rating}}（TAR {{score}}）— 正在跳转...',
      'Submit failed': '提交失败',
      'Get CPN Rating (1 credit)': '获取 TAR 评级（1 credit）',
      'Back': '返回',
      'No plants to compare. Select 2+ plants from your portfolio.': '没有可比较的电站。请先从你的项目中选择至少 2 个电站。',
      'Technology': '技术类型',
      'Capacity (kWp)': '容量（kWp）',
      'PLR (%/yr)': 'PLR（%/年）',
      'Availability (%)': '可用率（%）',
      'Annual Revenue': '年收入',
      'NPV Impact': 'NPV 影响',
      'Attribute': '属性',
      'Compare {{count}} Plants': '对比 {{count}} 个电站',
      'Submit for Rating': '提交评级',
      'This will use 1 credit. You have {{count}} credit(s) remaining.': '此操作将消耗 1 credit。你当前剩余 {{count}} 个 credit。',
      'Submit': '提交',
      '{{count}} credit(s) remaining': '剩余 {{count}} 个 credit',
      'No credits remaining': '没有剩余 credit',
      'Complete all required documents first': '请先完成所有必需资料',
      'Overall Risk Score': '总体风险分',
      'Not analyzed': '未分析',
      'Executive Summary': '执行摘要',
      'Analyzing climate, terrain and geopolitical risks... (~30s)': '正在分析气候、地形和地缘政治风险...（约 30 秒）',
      'No analysis yet. Click "Run Analysis" to generate.': '尚未生成分析。点击“运行分析”开始。',
      'Re-analyze': '重新分析',
      'Run Analysis': '运行分析',
      'Ins. Premium': '保险保费',
      'no quote': '暂无报价',
      'Get quote': '获取报价',
      'Natural Risks': '自然风险',
      'Geographic / Terrain': '地理 / 地形',
      'Social & Political': '社会与政治',
      'Technical Risk Factors': '技术风险因素',
      'Performance Ratio (PR)': '性能比（PR）',
      'Benchmark: ≥ 75% good, 65–75% monitor, < 65% critical': '基准：≥ 75% 良好，65–75% 需关注，< 65% 为高风险',
      'Degradation Rate (PLR)': '衰减率（PLR）',
      'Benchmark: > -0.8%/yr good, -0.8 to -1.2% caution': '基准：> -0.8%/年 良好，-0.8 至 -1.2% 需关注',
      'Benchmark: ≥ 97% good, 93–97% caution': '基准：≥ 97% 良好，93–97% 需关注',
      'Energy Performance Index (EPI)': '能效指数（EPI）',
      'Higher is better. < 0.10 indicates underperformance': '越高越好。< 0.10 表示表现偏弱',
      'Financial & Compliance Risk Factors': '财务与合规风险因素',
      'Revenue Loss vs Design': '相对设计值的收入损失',
      'Annual revenue shortfall vs design yield': '相对设计发电量的年度收入缺口',
      'Net present value impact of current underperformance': '当前低表现带来的净现值影响',
      'QE Verification': 'QE 核验',
      'QELabs on-site or document verification': 'QELabs 现场或文档核验',
      'Satellite Confirmation': '卫星确认',
      'Remote sensing data cross-validation': '遥感数据交叉验证',
      'Verification': '验证',
      'KYC Verification': 'KYC 核验',
      'Asset Overview': '资产概览',
      'Asset': '资产',
      'Market Status': '市场状态',
      'listed': '已挂牌',
      'pending approval': '待审批',
      'COD': '投运日期',
      'Submitted for Rating': '提交评级时间',
      'Owner Account': '业主账号',
      'Administrative address': '行政地址',
      'Data Basis': '数据依据',
      'Assessment Data Range': '评估数据范围',
      'SCADA Records Used': '使用的 SCADA 记录数',
      'This rating version does not include usable SCADA timestamps. Assessment confidence may be limited.': '此评级版本不包含可用的 SCADA 时间戳，评估可信度可能受限。',
      'Ownership History': '权属历史',
      'No ownership transfers recorded yet.': '暂无权属转移记录。',
      'Invitation Pending': '邀请待确认',
      'Sale Completion': '交易完成',
      'Admin Reassignment': '管理员重新分配',
      'Evidence': '证明材料',
      'Copy Claim Link': '复制认领链接',
      'Analyzing...': '分析中...',
      'Re-analyze Satellite': '重新分析卫星图像',
      'Verify Satellite': '核验卫星图像',
      'Count Modules': '计算组件数量',
      'QE Verified': 'QE 已核验',
      'Satellite': '卫星',
      'Pending': '待处理',
      'Confirmed': '已确认',
      '✓ PV Detected': '✓ 已检测到光伏电站',
      '✗ PV Not Detected': '✗ 未检测到光伏电站',
      'System-captured satellite image': '系统抓取的卫星图像',
      '© Google Maps · ↗ open': '© Google Maps · ↗ 打开',
      'Open in Google Maps': '在 Google Maps 中打开',
      'Open in TianDiTu': '在天地图中打开',
      'Insurance Risk Profile': '保险风险画像',
      'Risk': '风险',
      'Premium %': '保费比例',
      'Coverage': '保障范围',
      'Guarantee': '担保',
      'Annual Est.': '年度估算',
      'Click the Insurance Quote button at the top to generate a risk profile.': '点击顶部的“保险报价”按钮生成风险画像。',
      'Plant Files': '电站文件',
      'File deleted': '文件已删除',
      'Failed to delete file': '删除文件失败',
      '{{name}} uploaded': '{{name}} 已上传',
      '{{name}} upload failed': '{{name}} 上传失败',
      'Uploading...': '上传中...',
      'Drag files here or click to upload': '将文件拖到此处或点击上传',
      'SCADA CSV, inspection reports, photos, CAD drawings, etc.': '支持上传 SCADA CSV、巡检报告、照片、CAD 图纸等。',
      'No files uploaded yet': '还没有上传文件',
      'Delete this file?': '确认删除这个文件？',
      'Upload documents to see the checklist.': '上传资料后即可查看清单。',
      'Missing': '缺失',
      'Optional': '可选',
      '{{done}}/{{total}} steps completed': '已完成 {{done}} / {{total}} 个步骤',
      '+{{count}} more files': '另有 {{count}} 个文件',
      'Confirm Delete': '确认删除',
      'Delete project “{{name}}”? This action cannot be undone.': '确认删除项目“{{name}}”？此操作不可撤销。',
      'Project deleted': '项目已删除',
      'Delete failed': '删除失败',
      'Delete failed: {{msg}}': '删除失败：{{msg}}',
      'Renamed': '已重命名',
      'Renamed (offline)': '已重命名（离线）',
      'Copy': '副本',
      'Copied as “{{name}}”': '已复制为“{{name}}”',
      'Copied as “{{name}}” (offline)': '已复制为“{{name}}”（离线）',
      'AI-powered renewable asset modeling and evaluation platform': 'AI 驱动的新能源资产建模与评估平台',
      'Help': '使用帮助',
      'New Project': '新建项目',
      'Search projects...': '搜索项目...',
      'All Scenes': '全部场景',
      'Flat Roof': '平屋顶',
      'Pitched Roof': '坡屋顶',
      'Ground Mount': '地面电站',
      'Carport': '车棚',
      'Floating': '水面漂浮',
      'All Statuses': '全部状态',
      'Configured': '已配置',
      'Simulating': '仿真中',
      'Completed': '已完成',
      'Failed': '失败',
      'Sort By': '排序方式',
      'Recently Updated': '最近更新',
      'Created Time': '创建时间',
      'AI analysis completed': 'AI 分析完成',
      'Loading project...': '加载项目中...',
      'Result Details': '结果详情',
      'Project ID': '项目 ID',
      'Task 10 chart implementation': 'Task 10 图表实现',
      'Loading 3D globe...': '加载 3D 地球中...',
      'Project': '项目',
      'Version History': '版本历史',
      'Export': '导出',
      'Version History & Comparison': '版本历史与对比',
      'Scene Configuration': '场景配置',
      'Simulation Control': '仿真控制',
      'Simulation Results': '仿真结果',
      'No projects yet. Click “New Project” to get started.': '暂无项目，点击“新建项目”开始。',
      '{{total}} projects': '共 {{total}} 个项目',
      'Open Project': '打开项目',
      'Rename': '重命名',
      'Duplicate Project': '复制项目',
      'Modules': '组件',
      '{{count}} pcs': '{{count}} 块',
      'Area': '面积',
      'Irradiance': '辐照',
      'Yield': '发电',
      'Updated': '更新',
      'You can upload up to {{count}} files': '最多上传 {{count}} 个文件',
      'Total file size cannot exceed {{count}} MB': '文件总大小不能超过 {{count}} MB',
      'Create failed': '创建失败',
      'File upload failed: {{msg}}': '文件上传失败：{{msg}}',
      'Please check network or file size': '请检查网络或文件大小',
      'Project “{{name}}” created': '项目“{{name}}”已创建',
      'Skip and draw directly on the map': '跳过，直接在地图上绘制',
      'Create Project and Analyze': '创建项目并分析',
      'Create Project': '创建项目',
      'Project Name': '项目名称',
      'Optional. It will be auto-named from location if left blank.': '可选。若留空，将根据位置自动命名。',
      'Scene Type': '场景类型',
      'Optional. AI will try to detect it automatically.': '可选。AI 会尝试自动识别。',
      'Upload Files (Optional)': '上传文件（可选）',
      'Click or drag files to this area': '点击或拖拽文件至此区域',
      'Supports 3D models, boundary files, weather data, and more · up to {{files}} files · total size ≤ {{size}} MB': '支持 3D 模型、边界文件、气象数据等 · 最多 {{files}} 个文件 · 总大小 ≤ {{size}} MB',
      '{{count}} files, {{size}} total': '共 {{count}} 个文件，合计 {{size}}',
      'Uploading files...': '正在上传文件...',
      'Carport PV': '车棚光伏',
      'Distributed': '分布式',
      'Mountain': '山地',
      'Ground': '地面',
      'Hybrid Wind + Solar': '风光',
      'Tracking': '跟踪',
      'Bifacial': '双面',
      'Starting simulation system...': '正在启动仿真系统...',
      'Simulation cancelled': '仿真已取消',
      'Simulation completed': '仿真任务已完成',
      'Simulation failed': '仿真运行出错',
      'Ready': '就绪',
      'Queued': '排队中',
      'Running': '运行中',
      'Paused': '暂停',
      'Cancelled': '已取消',
      'Time Resolution': '时间步长',
      '5 min': '5 分钟',
      '10 min': '10 分钟',
      '15 min': '15 分钟',
      '30 min': '30 分钟',
      '60 min': '60 分钟',
      'Start Simulation': '开始仿真',
      'Reset': '重置',
      'Simulation Completed': '仿真完成',
      'Energy Yield': '发电量',
      'Specific Yield': '比发电量',
      'Capacity Factor': '容量因数',
      'Load Detailed Results': '加载详细结果',
      'New Simulation': '新建仿真',
      'Simulation in progress...': '仿真运行中...',
      'View results after simulation completes': '完成仿真后查看结果',
      'Heatmap': '热力图',
      'Losses': '损耗',
      'Finance': '财务',
      'Result Overview': '结果总览',
      'Generating design report...': '正在生成设计报告...',
      'Generate Report': '生成报告',
      'Preparing data download...': '正在打包下载数据...',
      'Download Data': '下载数据',
      'Annual Energy Yield': '年发电量',
      'Performance Ratio PR': '性能比 PR',
      'System efficiency indicator': '系统效率指标',
      'Please finish the simulation before exporting': '请先完成仿真后再导出',
      '{{label}} exported successfully': '{{label}} 导出成功',
      'Export failed, please try again': '导出失败，请重试',
      'PDF report exported successfully': 'PDF 报告导出成功',
      '3D scene not loaded, unable to capture screenshot': '3D 场景未加载，无法截图',
      'Screenshot saved': '截图已保存',
      'Screenshot failed': '截图失败',
      'Select Report Sections': '选择报告内容',
      'Generate PDF': '生成 PDF',
      '{{selected}} / {{total}} sections selected': '已选 {{selected}} / {{total}} 个章节',
      'PDF Report': 'PDF 报告',
      'Full simulation report (~2MB)': '完整仿真结果报告（约 2MB）',
      'Excel Data': 'Excel 数据',
      'All time-series data and KPI tables': '所有时序数据和 KPI 表格',
      'DXF Drawing': 'DXF 图纸',
      'Array layout CAD drawing': '阵列布局 CAD 图纸',
      '3D Screenshot': '3D 截图',
      'Current 3D viewport capture (PNG)': '当前 3D 视角截图（PNG）',
      'Simulation Overview': '仿真概览',
      'Irradiance Analysis': '辐照度分析',
      'Energy Yield Curve': '发电量曲线',
      'Financial Analysis': '财务分析',
      'System Configuration': '系统配置',
      'Overall Progress': '总体进度',
      'Waiting for server response... (no message for 30s)': '等待服务器响应...（30 秒无消息）',
      'Elapsed {{time}}': '已用 {{time}}',
      'Ground Type': '地面类型',
      'Annual Average Albedo': '年均反射率',
      'Monthly Albedo': '月度反射率',
      'Switch to "Custom" to edit monthly values': '切换到“自定义”后可编辑月度值',
      'Enable Bifacial Modules': '启用双面组件',
      'On': '开',
      'Off': '关',
      'Enable bifacial mode to capture rear-side diffuse irradiance and increase yield by 5%–15%.': '启用双面模式后，可利用背面散射辐照，使发电量提升 5%–15%。',
      'Bifaciality': '双面率',
      'Current Value': '当前值',
      'Structure Shading Factor': '结构遮挡因子',
      'Bifaciality: rear-side efficiency divided by front-side efficiency, typically 0.65–0.80.': '双面率：背面效率 / 正面效率，通常为 0.65–0.80。',
      'Structure shading: percentage of rear-side shading caused by racks and structural members.': '结构遮挡：支架等结构对背面的遮挡比例。',
      'Distributed rooftop: select roof faces to auto-place modules': '分布式屋顶：选择屋面后自动排布组件',
      'Location': '位置',
      'Latitude (°N)': '纬度 (°N)',
      'Longitude (°E)': '经度 (°E)',
      'Elevation (m)': '海拔 (m)',
      'Array Parameters': '组串参数',
      'Tilt (°)': '倾角 (°)',
      'Azimuth (°)': '方位角 (°)',
      'Roof Installation': '屋顶安装',
      'Edge Offset (m)': '边缘偏移 (m)',
      'Roof Overhang Setback (m)': '屋檐退缩 (m)',
      'Row Gap (m)': '行间隙 (m)',
      'Floating Platform Parameters': '浮体参数',
      'Pontoon Width (m)': '浮桥宽度 (m)',
      'Water Coverage Ratio': '水面覆盖率',
      'Anchor Offset (m)': '锚点退缩 (m)',
      'Floating scenarios automatically apply water-surface albedo (~0.06) and water-cooling temperature correction.': '水面漂浮场景自动采用水面反射率（约 0.06），并使用水冷温度修正。',
      'Please create or open a project first': '请先创建或打开一个项目',
      '{{name}} uploaded successfully': '{{name}} 上传成功',
      '{{name}} upload failed: {{msg}}': '{{name}} 上传失败：{{msg}}',
      'Unknown error': '未知错误',
      'Supports CAD/KML boundaries, PDF drawings, weather datasets, and other project materials.': '支持导入 CAD/KML 边界、PDF 图纸、气象数据集等项目相关资料。',
      'Supports single or batch upload': '支持单次或批量上传',
      'Uploaded Files': '已上传资料',
      'Module Model': '组件型号',
      'Search CEC database...': '搜索 CEC 数据库...',
      'Power': '功率',
      'Efficiency': '效率',
      'Dimensions': '尺寸',
      'Temperature Coefficient': '温度系数',
      'Power (Wp)': '功率 (Wp)',
      'Efficiency (%)': '效率 (%)',
      'Mountain Parameters': '山地参数',
      'Terrain-following Installation': '地形跟踪安装',
      'Ground Clearance (m)': '离地高度 (m)',
      'Slope Threshold (°)': '坡度阈值 (°)',
      'Mountain scenarios automatically analyze terrain slope and exclude areas beyond the threshold.': '山地场景会自动分析地形坡度，并排除超过阈值的区域。',
      'Tracking Mode': '跟踪方式',
      'Fixed': '固定',
      'Single Axis': '单轴',
      'Dual Axis': '双轴',
      'Ground Coverage Ratio (GCR)': '地面覆盖率 (GCR)',
      'GCR': 'GCR',
      'Single-axis Parameters': '单轴参数',
      'Max Rotation Angle (°)': '最大旋转角 (°)',
      'Backtracking': '回退跟踪',
      'Dual-axis Parameters': '双轴参数',
      'Azimuth Range (°)': '方位范围 (°)',
      'Max Tilt Angle (°)': '最大仰角 (°)',
      'Fixed Tilt': '固定倾角',
      'Drag a boundary file here': '拖拽边界文件到此处',
      'Supports GeoJSON / KML / Shapefile(zip) · up to {{size}} MB': '支持 GeoJSON / KML / Shapefile(zip) · 最大 {{size}} MB',
      'Drag a 3D model file here, or click to upload': '拖拽 3D 模型文件到此处，或点击上传',
      'Up to {{size}} MB': '最大 {{size}} MB',
      'AI File Analysis Result': 'AI 文件分析结果',
      'Intent': '意图',
      'Scene': '场景',
      'Suggested Name': '建议名称',
      'Detected Files ({{count}})': '文件识别结果（{{count}} 个）',
      'Recommended Next Steps': '建议下一步操作',
      'Modify Plan': '修改计划',
      'Confirm and Start': '确认并开始',
      'AI Chat': 'AI 对话',
      'Fetch Weather': '获取气象',
      'Auto Layout': '自动排布',
      'Shading Analysis': '遮挡分析',
      'Energy Estimate': '发电评估',
      'Full Analysis': '完整分析',
      'Simulation': '仿真计算',
      'Panel Shading Analysis': '组件遮挡分析',
      'Please link a project before uploading files': '请先关联一个项目再上传文件',
      'AI Assistant': 'AI 助手',
      'Online': '在线',
      'Clear Chat': '清空对话',
      'Hello! I am the SunSim AI assistant. I can help analyze PV projects, fetch weather data, and estimate energy yield. Ask a question or choose a quick action to begin.': '您好！我是 SunSim AI 助手，可以帮您分析光伏项目、获取气象数据、评估发电量等。请输入问题或选择快捷操作开始。',
      'Quick Actions': '快捷操作',
      'Pasted Image {{index}}': '粘贴图片 {{index}}',
      'Image {{index}}': '图片 {{index}}',
      'Upload Attachment': '上传附件',
      'Type a question... (Enter to send, Shift+Enter for newline, images can be pasted)': '输入问题...（Enter 发送，Shift+Enter 换行，可粘贴图片）',
      'Voice input is coming soon': '语音输入功能即将上线',
      'AI is thinking...': 'AI 正在思考...',
      'Please draw the project boundary on the map first': '请先在地图上绘制项目范围',
      'Invalid boundary polygon': '边界多边形无效',
      'Layout completed: {{modules}} modules ({{capacity}} kW), {{subarrays}} blocks, row pitch {{pitch}} m, GCR={{gcr}}%': '排布完成：{{modules}} 块组件（{{capacity}} kW），{{subarrays}} 个方阵，行距 {{pitch}} m，GCR={{gcr}}%',
      'Layout failed': '排布失败',
      'Layout failed: {{msg}}': '排布失败：{{msg}}',
      'Mounting Orientation': '安装方式',
      'Landscape (long edge horizontal)': '横装（长边水平）',
      'Portrait (long edge along the slope)': '竖装（长边沿斜面）',
      'Rows Up': '上下排数',
      'Modules Across': '横向组件数',
      'Module Gap (m)': '组件间距 (m)',
      'Row Pitch (Code-based)': '行距（国标）',
      'Winter Solstice Sun Hours (h)': '冬至日日照 (h)',
      'GB 50797: front-to-back spacing is automatically calculated to guarantee {{hours}} h of sunshine on the winter solstice.': 'GB 50797：前后排间距按冬至日保证 {{hours}} h 日照自动计算',
      'Blocks and Aisles': '方阵与通道',
      'Max Block Power (kW)': '方阵上限 (kW)',
      'Maintenance Aisle (m)': '检修通道 (m)',
      'Aisle Interval': '行间通道间隔',
      '0 = disabled': '0 = 不加',
      'Terrain': '地形',
      'Level Terrain Before Layout': '排布前平整地形',
      'Terrain Leveling': '地形平整',
      'Leveling Strategy': '平整策略',
      'Auto (terrain-based)': '自动（根据地形）',
      'Full leveling': '全局平整',
      'Stepped leveling': '台阶平整',
      'No leveling (follow slope)': '不平整（顺坡）',
      'Auto strategy': '自动策略',
      'Follow slope': '顺坡排布',
      '(based on {{type}} terrain)': '（基于 {{type}} 地形）',
      'Max Cut Depth (m)': '最大挖深 (m)',
      'Max Fill Height (m)': '最大填高 (m)',
      'Layout': '排布',
      'Azimuth {{azimuth}}°, tilt {{tilt}}°, computed by the Rust engine.': '方位角 {{azimuth}}°，倾角 {{tilt}}°，由 Rust 引擎计算',
      'Calculating layout...': '排布计算中...',
      'Draw Project Boundary First': '请先绘制项目范围',
      'Layout cleared': '排布已清除',
      'Clear Layout': '清除',
      'Installed kW': '装机 kW',
      'Blocks': '方阵',
      'GCR%': 'GCR%',
      'Click on the map to place turbines. Press ESC to exit.': '点击地图放置风机位置，按 ESC 退出',
      'Please place turbines first': '请先放置风机',
      'Please place PV modules first': '请先排布光伏组件',
      'Shadow analysis completed: average shading {{avg}}%, affecting {{count}} modules': '阴影分析完成：平均遮挡率 {{avg}}%，影响 {{count}} 块组件',
      'Shadow analysis failed: {{msg}}': '阴影分析失败：{{msg}}',
      'Turbine Parameters': '风机参数',
      'Turbine Model': '风机型号',
      'Select a model': '选择型号',
      'Turbine Count': '风机数量',
      'Hub Height (m)': '轮毂高度 (m)',
      'Rotor Diameter (m)': '转子直径 (m)',
      'PV Exclusion Radius (m)': 'PV 排除半径 (m)',
      'Turbine Placement': '风机放置',
      'Placing... (ESC to exit)': '放置中...（ESC 退出）',
      'Add Turbine': '添加风机',
      'Turbine': '风机',
      'Rated Power': '额定功率',
      'Hub Height': '轮毂高度',
      'Rotor Diameter': '叶轮直径',
      'Exclusion Radius': '排除半径',
      'Coordinates': '坐标',
      'Recommended Exclusion Radius': '推荐排除半径',
      '2.5D rule': '2.5D 原则',
      '{{count}} turbines placed': '已放置 {{count}} 台风机',
      'Monthly Yield': '月发电量',
      'Cumulative Yield': '累计发电量',
      'Cumulative': '累计',
      'Average': '平均',
      'No yield data available': '暂无发电量数据',
      'Monthly': '月度',
      '25 Years': '25 年',
      'No finance data available': '暂无财务数据',
      'Financial Metrics': '财务指标',
      'Levelized cost of energy': '平准化度电成本',
      'Internal rate of return': '内部收益率',
      'Net present value (25-year horizon)': '净现值（25 年期）',
      'Payback': '回收期',
      'years': '年',
      'Simple payback period': '静态投资回收期',
      'Initial Investment': '初始投资',
      'Annual O&M Cost': '年运维成本',
      'year': '年',
      'No heatmap data available': '暂无热力图数据',
      'Monthly × Hourly Irradiance Heatmap (W/m²)': '月×时辐照度热力图 (W/m²)',
      'No irradiance data available': '暂无辐照数据',
      'Irradiance Time Series (W/m²)': '辐照度时序 (W/m²)',
      'Loss': '损耗',
      'Baseline': '基准',
      'No loss data available': '暂无损耗数据',
      'Loss Waterfall (kWh/m²)': '损耗瀑布图 (kWh/m²)',
      'Probability Density': '概率密度',
      'No P50/P90 data available': '暂无 P50/P90 数据',
      'P50/P90 Probability Distribution': 'P50/P90 概率分布',
      'MM-DD': 'MM-DD',
      'Winter Solstice': '冬至',
      'Summer Solstice': '夏至',
      'Spring Equinox': '春分',
      'Autumn Equinox': '秋分',
      'Auto-analyze while dragging the slider': '拖动滑块时自动分析',
      'Run Shading Analysis': '计算遮挡',
      'Clear Results': '清除结果',
      'Shaded Strings': '受遮挡组串',
      'Average Shading': '平均遮挡率',
      'Max Shading': '最大遮挡率',
      'No Shading': '无遮挡',
      'Parameter': '参数',
      'Version Diff': '版本对比',
      'Configuration Diff': '配置差异',
      'Metric Changes': '指标变化',
      'Save Parameter Set': '保存参数配置',
      'Save Version Action': '保存',
      'Save Mode': '保存方式',
      'Update Current Version': '更新当前版本',
      'Save as New Version': '另存为新版本',
      'Version Name': '版本名称',
      'Please enter a version name': '请输入版本名称',
      'Example: v4 — bifacial + spacing optimization': '例：v4 — 双面 + 间距优化',
      'Description (Optional)': '描述（可选）',
      'Briefly describe this optimization...': '简述本次优化内容...',
      'Current': '当前',
      'Restore this version': '恢复此版本',
      'Restore': '恢复',
      'Compare with current version': '与当前版本对比',
      'Delete the current version?': '确定要删除当前版本吗？',
      'Delete this version?': '确定要删除该版本吗？',
      'Delete version': '删除版本',
      'Upload a DXF drawing in the Files section, then parse and align it to the map here.': '在“资料”页上传 DXF 图纸后，可在此解析并对齐到地图。',
      'DXF drawing detected': '已检测到 DXF 图纸',
      'Parsing...': '解析中...',
      'Parse Drawing': '解析图纸',
      'Panels': '组件',
      'Cables': '电缆',
      'Inverters': '逆变器',
      'Layer': '图层',
      'Count': '数量',
      'Type': '类型',
      'AI aligning...': 'AI 分析对齐中...',
      'AI Auto Align': 'AI 自动对齐',
      'Manual Align': '手动对齐',
      'Manual Alignment Mode': '手动对齐模式',
      'Click on the map to set the center point, then adjust parameters to align the drawing with satellite imagery.': '点击地图设置中心点，调整参数使图纸与卫星影像对齐。',
      'Center Position': '中心位置',
      'Longitude': '经度',
      'Latitude': '纬度',
      'Lon': '经',
      'Lat': '纬',
      'Rotation': '旋转',
      'Scale (DXF units / m)': '比例（DXF 单位 / 米）',
      'Opacity': '透明度',
      'Confirm Alignment': '确认对齐',
      'Alignment Result': '对齐结果',
      'Unknown': '未知',
      'offset from true north': '偏离正北',
      'Scale': '比例',
      'unit': '单位',
      'scale': '比例',
      'Confidence': '置信度',
      'AI Reasoning': 'AI 推理过程',
      'Apply to Map': '应用到地图',
      'Rendered {{count}} components / blocks onto the map': '已渲染 {{count}} 个组件/方阵到地图',
      'Clear DXF Layers': '清除 DXF 图层',
      'Link copied to clipboard': '链接已复制到剪贴板',
      'Share Report': '分享报告',
      'Share this link to give read-only access to the rating report:': '分享此链接可授予他人对评级报告的只读访问权限：',
      'QR Code': '二维码',
      'No plants to display': '暂无可显示的电站',
      '{{visible}} / {{total}} on map': '{{visible}} / {{total}} 个已显示在地图上',
      'COLOR = RATING': '颜色 = 评级',
      'SHAPE = STATUS': '形状 = 状态',
      '● Rated': '● 已评级',
      '▲ Analyzing': '▲ 分析中',
      '■ Draft': '■ 草稿',
      '★ Listed': '★ 已上架',
      'No location': '无位置',
      'Current Issue': '当前问题',
      'Requested Support': '所需支持',
      'Expected Outcome': '期望结果',
      'Additional Notes': '补充说明',
      'Support request updated': '支持请求已更新',
      'Support Requests': '支持请求',
      'Improve via Chat': '通过聊天改进',
      'No support request yet': '暂无支持请求',
      'Click Improve to open chat, confirm your need, and save an inspection or optimization support request.': '点击 Improve 打开聊天，确认你的需求，并保存检测或优化支持请求。',
      'Requester': '请求人',
      'Latest Status Note': '最新状态备注',
      'Update Support Status': '更新支持状态',
      'Add a progress or completion note...': '补充进度或完成说明...',
      'Mark Open': '标记为 Open',
      'Mark In Progress': '标记为 In Progress',
      'Mark Completed': '标记为 Completed',
      'Previous Requests': '历史请求',
      'Back to home': '返回首页',
      'I agree to the': '我同意',
      'I have read and accept the current Terms and Conditions': '我已阅读并接受当前条款与条件',
      'Account created and purchased assets were linked.': '账号已创建，已购资产已关联。',
      'Failed to accept terms': '接受条款失败',
      // ── SellerPortfolio / DashboardPlantCard ──────────────────────────────
      'Prospect': '待开发',
      'Purchased': '已购入',
      'Self-created': '自建',
      'Create, rate, transfer...': '创建、评级、转让，为新能源资产上架市场做好准备。',
      'Create a new plant...': '创建新电站...',
      'Buy a plant...': '购买电站...',
      'Registered Capacity': '已注册容量',
      'Traded Capacity': '已交易容量',
      'Prospect Pipeline': '待开发管线',
      'Favorites': '收藏夹',
      'No favorites yet...': '暂无收藏...',
      'Add to Favorites': '加入收藏',
      'Submit to Market': '提交上架',
      'Delete Plant': '删除电站',
      'Search...': '搜索...',
      'My Created': '我创建的',
      'Seller:': '业主：',
      'Price/terms:': '价格/条款：',
      'Date:': '日期：',
      'Origin': '来源',
      'Transaction': '交易',
      'PLR/yr': 'PLR/年',
      'QE Approval': 'QE 审批',
      'On Market': '已上架',
      '↩ Withdraw': '↩ 撤回',
      '↑ Submit to Market': '↑ 提交上架',
      // ── ApprovalDashboard ─────────────────────────────────────────────────
      'Claim': '认领',
      'My Approvals': '我的审批',
      'Rating Queue': '评级队列',
      'Listing Requests': '上架申请',
      'Approved History': '已审批历史',
      'Rating Approvals': '评级审批',
      'CPN': 'TAR',
      'TAR': 'TAR',
      'No pending rating approvals': '暂无待审批评级',
      'No pending listing requests': '暂无待审批上架申请',
      'No approved items': '暂无已审批项目',
      'Approval Detail': '审批详情',
      'Claimed': '已认领',
      'Claim failed': '认领失败',
      'Approve failed': '审批失败',
      'Reject failed': '拒绝失败',
      'Failed to load approvals': '加载审批数据失败',
      'Listing approved': '上架申请已通过',
      'Failed to approve': '审批失败',
      'Listing rejected': '上架申请已拒绝',
      'Failed to reject': '拒绝失败',
      // ── LoginPage ─────────────────────────────────────────────────────────
      'Sign Up': '注册',
      'Remember me for 30 days': '记住我 30 天',
      'Terms of Service': '服务条款',
      'Agree & Continue': '同意并继续',
      'To continue, please agree to our Terms of Service.': '请同意我们的服务条款以继续。',
      'Read the full Terms of Service →': '阅读完整服务条款 →',
      'Terms and Conditions': '条款与条件',
      'Terms acceptance required': '需要接受条款',
      'One more step': '还差一步',
      'Complete the current terms acceptance to continue to your workspace.': '请完成当前条款确认，以继续进入工作台。',
      'Continue': '继续',
      'This claim link is no longer valid': '此认领链接已失效',
      'Please contact the platform team for the latest invitation link.': '请联系平台团队获取最新邀请链接。',
      'Continue with Google': '使用 Google 账号继续',
      'or': '或',
      'Free Health Check and Rate for all Renewable Energy Plants': '为所有新能源电站提供免费健康检查与评级',
      'Trusted by solar professionals across Southeast Asia.': '受东南亚太阳能专业人士信赖。',
      // ── Marketplace ───────────────────────────────────────────────────────
      'Solar Asset Marketplace': '太阳能资产交易市场',
      'My Favorites': '我的收藏',
      'Marketplace browsing is enabled': '市场浏览已开放',
      'You can browse listings. To express interest or contact owners, please accept the platform terms first.': '你可以浏览挂牌信息。如需表达意向或联系业主，请先接受平台条款。',
      'selected': '已选',
      'asset(s) selected for procurement': '个资产已选择采购',
      'Request Selected Purchases': '申请采购所选资产',
      'AI Search: ask anything about marketplace assets...': 'AI 搜索：询问任何关于市场资产的问题...',
      'AI Search': 'AI 搜索',
      'AI Search Results': 'AI 搜索结果',
      'AI-ranked': 'AI 排序',
      'fallback': '备用',
      'Traded': '已交易',
      'Top 5 Trending': '热门前 5',
      'MW': 'MW',
      'Cards': '卡片',
      'No assets matched your AI search query': '没有资产符合你的 AI 搜索条件',
      '✓ Selected': '✓ 已选',
      'Request Purchase': '申请采购',
      // ── MarketListingPage ─────────────────────────────────────────────────
      'Back to Marketplace': '返回市场',
      'Public listing not found': '未找到授权项目信息',
      'Open Internal Rating': '查看内部评级',
      'Express Interest': '表达意向',
      'Join Backup Waitlist': '加入候补名单',
      'Withdraw Interest': '撤回意向',
      'Backup Waitlist Pending': '候补名单待审核',
      'Pending Review': '待审核',
      'Contact Shared': '联系方式已共享',
      'Request Rejected': '申请已拒绝',
      'Claim Purchased Asset': '认领已购资产',
      'Withdraw Claim': '撤回认领',
      'Claim Pending Review': '认领待审核',
      'Claim Approved': '认领已通过',
      'Claim Rejected': '认领已拒绝',
      'Priority Access': '优先访问',
      'Public Listing Summary': '授权项目摘要',
      'Browse-only mode until terms are accepted': '条款接受前仅可浏览',
      'You can review the public listing summary. To express interest or contact the owner, please accept the platform terms first.': '你可以查看授权项目摘要。如需申请业主联系，请先接受平台条款。',
      'kWp': 'kWp',
      'Public CPN': '公开 TAR',
      'Public TAR': '公开 TAR',
      'Listing Snapshot': '挂牌快照',
      'Marketplace Status': '市场状态',
      'Priority Access Window': '优先访问窗口',
      'Active': '活跃',
      'Public Yield Signal': '公开收益信号',
      'Buyer contact and authorization actions are available after expressing marketplace interest.': '提交 fund 联系申请后可进行联系和授权操作。',
      'Marketplace Interest Status': 'Fund 联系申请状态',
      'Backup waitlist pending': '候补名单待审核',
      'Pending operator review': '待运营方审核',
      'Contact shared': 'LOI / 联系已批准',
      'Request rejected': '申请已拒绝',
      'Interest withdrawn': '意向已撤回',
      'Mode': '模式',
      'backup waitlist': '候补名单',
      'primary interest': '主要意向',
      'Contact release was approved. Owner contact details are shown below.': '联系方式已获批共享，业主联系方式如下。',
      'Owner Contact Locked': '业主联系方式已锁定',
      'Submit marketplace interest to unlock owner contact details.': '提交 fund 联系申请以解锁业主联系方式。',
      'Ownership Claim Status': '所有权认领状态',
      'Claim approved': '认领已通过',
      'Claim rejected': '认领已拒绝',
      'Claim withdrawn': '认领已撤回',
      'Need to claim this purchased asset?': '需要认领此已购资产？',
      'If this project was sold to you offline, submit a claim with supporting evidence for operator review.': '如果此项目是线下出售给你的，请提交带有支持证明的认领申请供运营方审核。',
      'Evidence Note': '证明材料',
      'Submit Claim': '提交认领',
      'Supporting Evidence': '支持证明',
      'Please explain the proof of purchase or transfer.': '请说明购买或转让的证明材料。',
      'Examples: signed SPA, invoice, or transfer confirmation.': '例如：已签署的 SPA、发票或转让确认书。',
      'Marketplace interest withdrawn': 'Fund 联系申请已撤回',
      'Ownership claim withdrawn': '所有权认领已撤回',
      'Loading public listing...': '正在加载授权项目信息...',
      'Loading authorized project...': '正在加载授权项目信息...',
      'Disclosed after approval': '审批后披露',
      'Sale Pending': '待成交',
      'Sold': '已售出',
      'Available': '可购入',
      'Request ID': '申请编号',
      'Deal Room': '交易工作室',
      'Failed to load deal': '加载交易失败',
      'Deal completed': '交易已完成',
      'Deal step updated': '交易步骤已更新',
      'Confirmation recorded': '确认已记录',
      'Failed to update deal step': '更新交易步骤失败',
      'Loading deal workflow...': '正在加载交易工作流...',
      'Deal not found': '未找到交易',
      'Back to Project': '返回项目',
      'Deal Completed': '交易完成',
      'Deal Active': '交易进行中',
      'Under Offer': '已锁定',
      'Due Diligence': '尽调中',
      'Escrow': '尽调付款中',
      'Diligence Payment': '尽调付款',
      'Closing': '交割中',
      'Track LOI, KYC, site inspection, escrow payment, transfer procedures, and fund release in one workflow.': '意向书、KYC、现场检查、托管付款、交割手续和放款状态集中记录。',
      'Track LOI, initial price, non-binding offer, LDD, QE site inspection, diligence payment, full report, final terms, binding agreement, and payment/closing.': '集中记录 LOI、初步价格、non-binding offer、LDD、QE 现场检测、尽调付款、完整报告、最终条款、binding agreement、付款与交割。',
      'Asset Snapshot': '资产概况',
      'Listing ID': '上架 ID',
      'Current Step': '当前步骤',
      'This project has been removed from marketplace and marked as sold.': '该项目已经从 marketplace 下架，并标记为已完成交易。',
      'Deal Workflow': '交易流程',
      'Buyer': '买方',
      'Deal Seller': '卖方',
      'Platform / Escrow': '平台/托管方',
      'Buyer & Seller': '买卖双方',
      'Fund': 'Fund',
      'Asset Owner': '资产业主',
      'QE Operator': 'QE 运营方',
      'Fund & Owner': 'Fund 与业主',
      'LOI / contact approved': 'LOI / 联系申请已通过',
      'Initial price discussion': '初步价格沟通',
      'Non-binding offer': 'Non-binding offer',
      'LDD started': 'LDD 启动',
      'QE site inspection': 'QE 现场检测',
      'QE site inspection scheduled': 'QE 现场检测安排',
      'Diligence payment': '尽调付款',
      'Full report delivered': '完整报告交付',
      'Final terms': '最终条款',
      'Binding agreement': '正式协议',
      'Payment and closing': '付款与交割',
      'Sign LOI and lock project': '签署意向书并锁定项目',
      'Legal / KYC review': 'Legal / KYC 审查',
      'Site inspection': '现场检查',
      'Escrow payment': '付款至第三方托管',
      'Transfer procedures': '办理交割手续',
      'Release funds and close': '放款并完成交易',
      'In Progress': '进行中',
      'Completed At': '完成时间',
      'Required Confirmations': '所需确认方',
      'Waiting': '待确认',
      'Waiting for': '等待确认方',
      'Optional confirmation note, such as document number, inspection conclusion, or escrow transaction ID.': '可填写本次确认备注，例如文件编号、检查结论、托管流水号等。',
      'Confirm Current Step': '确认当前步骤',
      'Already Confirmed': '已确认',
      'This step must be confirmed by another party.': '当前步骤需要由其他角色确认。',
    },
  },
} as const;

export type SupportedLanguage = keyof typeof resources;
